import * as $ from 'jquery';
import * as rebindTab from './rebindTab';
import * as SearchHistory from "./searchHistory";
export function initialize(): void {
    bindSort();
}

export function bindSort($context?: JQuery): void {
    ($context ? $context.find('.js-sortorder') : $('.js-sortorder')).on('click', handleClick);
}

function handleClick(event): void {
    event.preventDefault();

    const $element = $(this);
    const target = $element.data('target');
    const value = $element.data('sortorder');
    const $form = $element.closest('form');

    $(target).val(value);
    //$element.closest('form').submit();

    $.post($form.data('partialurl'), $form.serialize(), (response) => {
        const $response = $(`<div>${response}</div>`);
        const pageTabId = $form.find("input[name='tab']").val();
        const $pageTab = $("#tab-" + pageTabId);
        //const $pageTab = $element.closest('.js-tabcontent');
        const $responseTab = $response.find('.js-tabcontent-main:first');

        $pageTab.replaceWith($responseTab);
        rebindTab.rebind($responseTab);
        SearchHistory.update();

        const currentUrl = new URL(window.location.href);
        document.querySelectorAll<HTMLAnchorElement>(".pagination-container__pages a")
        .forEach(link => {
            const linkUrl = new URL(link.href);
            currentUrl.searchParams.forEach((value, key) => {
                if (key !== "page") {
                    linkUrl.searchParams.set(key, value);
                }
            });
            link.href = linkUrl.toString();
        });
    });
}